import { useAppSelector } from "../hooks"
import { getOrderState } from "../store"
import SuccessIcon from "../assets/icons/SuccessIcon";
import { Link } from "react-router-dom";
import { IProductOrderPayload } from "../types/order";
export default function ThankYouPage() {
    const { orderInfo } = useAppSelector(getOrderState);
    return (
        <div className="min-h-screen max-xl:min-h-fit max-sm:p-4 flex justify-center items-start bg-gray-200 max-xl:p-6 max-xl:items-center h-screen max-lg:h-screen z-50">
            <div className="flex flex-col gap-3 items-center bg-white w-1/2 max-xl:w-full p-12 max-md:p-6 rounded-xl mt-16 max-xl:mt-0">
                <SuccessIcon />
                <h1 className="text-3xl font-normal text-center">Đặt hàng thành công</h1>
                <p className="text-sm font-normal text-center">Đơn hàng của bạn đang được xử lý</p>
                <table className="w-full table-auto">
                    <thead className="text-center border-b border-gray-300 border-solid ">
                        <th className="py-2">Mã đơn</th>
                        <th className="py-2">Tổng tiền</th>
                        <th className="py-2">Trạng thái</th>
                    </thead>
                    <tbody className="mt-4">
                        <tr className="text-center">
                            <th className="py-2">{orderInfo.order_id}</th>
                            <th className="py-2">{orderInfo?.total_price.toLocaleString("vi-VN")}</th>
                            <td className="py-2">Chưa thanh toán</td>
                        </tr>
                    </tbody>
                </table>
                <div className="py-1 w-full"></div>
                <table className="w-full table-auto">
                    <thead className="border-b border-gray-300 border-solid">
                        <th className="text-left py-2">Sản phẩm</th>
                        <th className="text-right py-2">Giá bán</th>
                    </thead>
                    <tbody>
                        {orderInfo.products.length > 0 && orderInfo?.products?.map((product: IProductOrderPayload) => (
                            <tr key={product.product_id}>
                                <td className="text-left py-2">{product.quantity} x {product.product_name}</td>
                                <td className="text-right py-2">{product.price_sale.toLocaleString("vi-VN")}</td>
                            </tr>
                        ))}
                        <tr>
                            <td colSpan={2} className="text-right py-2">Tổng tiền: <span className="font-bold">{orderInfo.total_price.toLocaleString("vi-VN")}</span></td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="text-right py-2">
                                <Link className="py-2 px-3 bg-blue-500 text-white text-md font-medium rounded-md" to="/">
                                    Mua tiếp
                                </Link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div >
        </div >
    )
}